import React from 'react';
import { GhostIcon } from 'lucide-react';
import { BRAND_COMPANY, PRODUCT_NAME, footerLinks, footerTagline } from '../data/halloweenKit';
export function Footer() {
  const links = footerLinks.filter((l): l is {
    label: string;
    href: string;
  } => l.href !== null);
  return <footer className="w-full border-t border-night-600 bg-night-900 py-14" data-id="element-94" data-mp="36pfsvtwnvp46">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-95" data-mp="36nd5lhmw8a35">
        <GhostIcon className="mx-auto h-5 w-5 text-pumpkin" strokeWidth={1.5} aria-hidden="true" data-id="element-96" data-mp="3ug3efhzi2d97" />
        <p className="mt-3 font-display text-2xl font-semibold uppercase tracking-[0.18em] text-cream-50" data-id="element-97" data-mp="37o56rpk5rbs">
          {BRAND_COMPANY}
        </p>
        <div className="mt-4 space-y-0.5" data-id="element-98" data-mp="3lggfd2u8tjjb">
          {footerTagline.map(line => <p key={line} className="text-[14px] leading-relaxed text-body" data-id="element-99" data-mp="3qblyjtw9gk3p">
              {line}
            </p>)}
        </div>

        <p className="mt-8 text-[11px] font-semibold uppercase tracking-[0.22em] text-pumpkin" data-id="element-100" data-mp="2ey05hxna5ycw">{PRODUCT_NAME}</p>

        <nav aria-label="Legal" className="mt-8" data-id="element-101" data-mp="3l8qvw2zluhqx">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-102" data-mp="3lbmu7sfd78fw">
            {links.map(l => <li key={l.label} data-id="element-103" data-mp="3gcts0w5j33v1">
                <a href={l.href} className="whitespace-nowrap text-[13px] text-cream-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-pumpkin-light hover:underline" data-id="element-104" data-mp="3v89fgibls1ig">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="mt-8 border-t border-night-600 pt-8" data-id="element-105" data-mp="31uqdkpmchqy">
          <p className="text-[13px] leading-relaxed text-muted" data-id="element-106" data-mp="hrs7jgp4s76n">
            © 2026 Redondo Land LLC. All rights reserved.
            <br data-id="element-107" data-mp="cuiku8t4m9mi" />
            Unauthorized reproduction, resale, or redistribution prohibited.
          </p>
        </div>
      </div>
    </footer>;
}